import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { homeRoute } from '../route-names';
import { ApiAboutService } from '../Services/api-about.service';

@Component({
    selector: 'app-registration-success',
    templateUrl: './registration-success.component.html',
    styleUrls: ['./registration-success.component.scss'],
    standalone: false
})
export class RegistrationSuccessComponent implements OnInit {

  votingPin: string | undefined;

  constructor(private readonly router: Router,
    readonly aboutService: ApiAboutService) {}

  ngOnInit(): void {
  
    if (history.state.votingPin === true) {
      this.votingPin = undefined
    }
    else {
      this.votingPin = history.state.votingPin;
    }
    setTimeout(() => {
      this.resetFocus();
    },100);
  }

  exit(): void {
    this.router.navigate(homeRoute);
  }

  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    if (focusField) {
      focusField.focus()
         }
  }
}
